// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-dialog__content--active{-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px)}.altertClass{font-size:15px;font-weight:700;padding-left:5px}.v-application--is-ltr .v-list-group--no-action>.v-list-group__items>.v-list-item{padding:0 16px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
